import React from 'react';
import { colors } from '@insurancemenu/imenu-components-lib';
import { EXTERNAL_IM_LINKS } from 'global/utils/generalLinks';
import { ICustomizableElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { IconStyled, SupportMessageStyled } from './styles';

type SupportType = 'NEW_TO_IM' | 'WITH_IM_ACCOUNT' | 'PENDING_REGISTRATION';

interface Props extends ICustomizableElement {
  type: SupportType;
}

const SupportMessages = Object.freeze({
  NEW_TO_IM: (
    <span>
      New to IM? Click
      <a href={EXTERNAL_IM_LINKS.NEW_TO_IM}>here</a>to set up your account.
    </span>
  ),
  WITH_IM_ACCOUNT: (
    <span>
      Already have an account with us? Login
      <a href={`https://${process.env.REACT_APP_AUTH_FE_BASE_URL}/login`}>here.</a>
    </span>
  ),
  PENDING_REGISTRATION: <span>Complete registration using the link we emailed you earlier.</span>,
});

const SupportBlock: React.FC<Props> = ({ className, type }) => {
  return (
    <SupportMessageStyled className={className}>
      <IconStyled color={colors.green[600]} height="2rem" />
      {SupportMessages[type]}
    </SupportMessageStyled>
  );
};

export default SupportBlock;
